import { matchPath, useLocation } from 'react-router-dom';

import { routes } from 'constants/routes';

export const useIsLegacyOneOnOneInstance = () => {
  const location = useLocation();
  const { isExact } =
    matchPath<{ instanceId: string }>(location.pathname, {
      path: routes.oneOnOne.legacyInstance,
      exact: true,
    }) ?? {};

  return {
    isLegacyOneOnOneInstance: isExact,
  };
};
